import { DiscreteCarousel } from '../../../../Carousels/DiscreteCarousel/DiscreteCarousel';
import type { Image } from '../../../types/Image';
import { Video } from '../../../types/Video';
import { PostImage } from '../PostImage/PostImage';
import { PostVideo } from '../PostVideo/PostVideo';

interface PostMediaWrapperProps {
  userNickname: string | undefined;
  images: Image[] | null | undefined;
  video?: Video;
  isTouchDevice?: boolean;
}

export const PostMediaWrapper = ({
  userNickname,
  images,
  video,
  isTouchDevice,
}: PostMediaWrapperProps) => {
  const imageItems = images
    ? images.map(image => {
        return isTouchDevice ? (
          <div className="flex min-w-full justify-center" key={image.url}>
            <PostImage
              image={image}
              key={image.url}
              userNickname={userNickname}
              className="snap-center pb-[125%]"
            />
          </div>
        ) : (
          <div className="flex min-w-full justify-center" key={image.url}>
            <PostImage userNickname={userNickname} image={image} useImageDirection />
          </div>
        );
      })
    : [];
  const videoItem = video
    ? [
        <div className="flex min-w-full justify-center" key={video.screenshot.url}>
          <PostVideo
            className={isTouchDevice ? 'pb-[125%]' : ''}
            video={video}
            key={video.screenshot.url}
          />
        </div>,
      ]
    : [];
  const carouselItems = [...imageItems, ...videoItem];
  return (
    <DiscreteCarousel
      className="relative w-full"
      id="PostMediaWrapper"
      innerWrapperClassName="h-full"
      lightBackground={false}
      pageIndicatorClassName="absolute bottom-6 left-[50%] translate-x-[-50%]"
      withoutDefaultContainerClasses
    >
      {carouselItems}
    </DiscreteCarousel>
  );
};
